<template>
  <b-card no-body class="card-developer-meetup cursor_pointer">
    <div class="bg-light-primary rounded-top text-center">
      <div
        :class="`${info.ngo === null ? 'bg-warning' : ''}`"
        class="header_card"
      >
        <h6 class="text-white">
          {{ info.ngo === null ? "الوزارة" : info.ngo.name_ar }}
        </h6>
      </div>
      <b-img
        :src="require('@/assets/event/event_default.svg')"
        alt="Event Image"
        height="170"
        class="w-100"
      />
    </div>
    <b-card-body>
      <div class="meetup-header d-flex align-items-center">
        <div class="meetup-day">
          <h6 class="mb-0">
            {{ ar_months[new Date(info.from_event_duration).getMonth()] }}
          </h6>
          <h3 class="mb-0">
            {{
              new Date(info.from_event_duration).toLocaleString("en-us", {
                day: "2-digit",
              })
            }}
          </h3>
        </div>
        <div class="my-auto">
          <b-card-title v-if="info.title_ar" class="mb-25">
            {{ info.title_ar }}
          </b-card-title>
        </div>
      </div>

      <!-- media -->
      <b-media no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            :variant="`${info.ngo_id == 0 ? 'light-warning' : 'light-primary'}`"
            size="34"
          >
            <feather-icon icon="GridIcon" size="18" />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0" v-if="info.eventType">
            النوع : {{ info.eventType.title_ar }}
          </h6>
        </b-media-body>
      </b-media>

      <b-media no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            :variant="`${info.ngo_id == 0 ? 'light-warning' : 'light-primary'}`"
            size="34"
          >
            <feather-icon icon="CalendarIcon" size="18" />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            {{ info.from_event_duration }}
          </h6>
          <small>
            من <span>{{ info.from_time.slice(0, 5) }}</span>
          </small>
          <small class="mx-50">إلى</small>
          <small
            ><span>{{ info.to_time.slice(0, 5) }}</span></small
          >
        </b-media-body>
      </b-media>

      <b-media no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            :variant="`${info.ngo_id == 0 ? 'light-warning' : 'light-primary'}`"
            size="34"
          >
            <feather-icon icon="UsersIcon" size="18" />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            الدعوة : {{ info.invitation_type ? "عامة" : "خاصة" }}
          </h6>
        </b-media-body>
      </b-media>

      <b-media no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            :variant="`${info.ngo_id == 0 ? 'light-warning' : 'light-primary'}`"
            size="34"
          >
            <feather-icon icon="MapPinIcon" size="18" />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            {{ info.location }}
          </h6>
        </b-media-body>
      </b-media>
    </b-card-body>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      block
      variant="primary"
    >
      التفاصيل
    </b-button>
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BCardBody,
  BCardText,
  BCardTitle,
  BMedia,
  BMediaAside,
  BAvatar,
  BAvatarGroup,
  VBTooltip,
  BMediaBody,
  BButton,
  BModal,
  VBModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

/* eslint-disable global-require */
export default {
  components: {
    BCard,
    BImg,
    BCardBody,
    BCardText,
    BCardTitle,
    BMedia,
    BMediaAside,
    BAvatar,
    BAvatarGroup,
    BMediaBody,
    Ripple,
    BButton,
    BModal,
    VBModal,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },

  props: ["info", "activ"],
  data() {
    return {
      mediaData: [
        {
          avatar: "CalendarIcon",
          title: "Sat, May 25, 2020",
          subtitle: "10:AM to 6:PM",
        },
        {
          avatar: "MapPinIcon",
          title: "Central Park",
          subtitle: "Manhattan, New york City",
        },
      ],
      ar_months: [
        "كانون الثاني",
        "شباط",
        "آذار",
        "نيسان",
        "أيار",
        "حزيران",
        "تموز",
        "آب",
        "أيلول",
        "تشرين الأول",
        "تشرين الثاني",
        "كانون الأول",
      ],
    };
  },
  methods: {
    getDay(date) {
      this.$moment(date, "YYMMDD");
    },
    getHour(FromDate, fromTime) {
      return `${new Date(`${FromDate} ${fromTime}`).getHours()} : ${new Date(
        `${FromDate} ${fromTime}`
      ).getMinutes()}`;
    },
  },
};
</script>

<style scoped>
.header_card {
  height: 50px;
  width: 100%;
  background: rgb(14 87 150);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
